export default __webpack_public_path__ + "static/media/fuel-consumption.4364e5f6.svg";